import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import useApiClient from '../../../../Shared/services/api';
import { EndpointQueryKeys } from '../../../constants/endpoints';
import { bulkUpdateGtmStatus } from '../services/service';

export interface BulkGtmStatusVariables {
  bookingIds: string[];
  gtmStatus: string;
}

/**
 * Mutation for the super-admin bulk GTM status change. On success it invalidates the booking sheet
 * so the grid reflects the new statuses, then runs the caller's onSuccess callback (used to close
 * the confirm modal, clear the row selection, and show a success message).
 */
export const useBulkGtmStatusMutation = (
  artEventId: string,
  onSuccessCb: () => void
) => {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<ApiResponseKeys, ApiError, BulkGtmStatusVariables>({
    mutationFn: ({ bookingIds, gtmStatus }: BulkGtmStatusVariables) =>
      bulkUpdateGtmStatus(api, artEventId, bookingIds, gtmStatus),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EndpointQueryKeys.GET_BOOKING_SHEET, artEventId],
      });
      onSuccessCb();
    },
  });
};
